import {Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {HospitalService} from '../../../../services/hospital.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TitleCasePipe} from '@angular/common';
import {LogService} from '../../../../services/log.service';
import {Observable, Subscription} from "rxjs";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {ConfirmDialogComponent} from "../../../../confirm-dialog/confirm-dialog.component";
import {DialogWithInputComponent} from "../../../../confirm-dialog/dialog-with-input/dialog-with-input.component";
import {CentreService} from "../../../../services/centre.service";
import {Centre} from "../../../../interfaces/Centres";
import {take} from "rxjs/operators";

@Component({
  selector: 'app-add-hospital',
  templateUrl: './add-hospital.component.html',
  styleUrls: ['./add-hospital.component.css']
})
export class AddHospitalComponent implements OnInit {
  addressForm!: FormGroup;
  deletedDrDetails: any[] = [];
  drDesignation$!: Observable<any[]>
  userData: any = JSON.parse(localStorage.getItem('userData')!);
  centres$!: Observable<Centre[]>;
  selectedCentreCode: any;
  isLoading: boolean = false;
  mState = [
    {code: "AN", name: "Andaman and Nicobar Islands"},
    {code: "AP", name: "Andhra Pradesh"},
    {code: "AR", name: "Arunachal Pradesh"},
    {code: "AS", name: "Assam"},
    {code: "BR", name: "Bihar"},
    {code: "CG", name: "Chandigarh"},
    {code: "CH", name: "Chhattisgarh"},
    {code: "DH", name: "Dadra and Nagar Haveli"},
    {code: "DD", name: "Daman and Diu"},
    {code: "DL", name: "Delhi"},
    {code: "GA", name: "Goa"},
    {code: "GJ", name: "Gujarat"},
    {code: "HR", name: "Haryana"},
    {code: "HP", name: "Himachal Pradesh"},
    {code: "JK", name: "Jammu and Kashmir"},
    {code: "JH", name: "Jharkhand"},
    {code: "KA", name: "Karnataka"},
    {code: "KL", name: "Kerala"},
    {code: "LD", name: "Lakshadweep"},
    {code: "MP", name: "Madhya Pradesh"},
    {code: "MH", name: "Maharashtra"},
    {code: "MN", name: "Manipur"},
    {code: "ML", name: "Meghalaya"},
    {code: "MZ", name: "Mizoram"},
    {code: "NL", name: "Nagaland"},
    {code: "OR", name: "Odisha"},
    {code: "PY", name: "Puducherry"},
    {code: "PB", name: "Punjab"},
    {code: "RJ", name: "Rajasthan"},
    {code: "SK", name: "Sikkim"},
    {code: "TN", name: "Tamil Nadu"},
    {code: "TS", name: "Telangana"},
    {code: "TR", name: "Tripura"},
    {code: "UK", name: "Uttarakhand"},
    {code: "UP", name: "Uttar Pradesh"},
    {code: "WB", name: "West Bengal"}]

  private duplicateCheckSubscription?: Subscription;

  constructor(
    private fb: FormBuilder,
    private hospitalService: HospitalService,
    private matDialogRef: MatDialogRef<AddHospitalComponent>,
    private snackBar: MatSnackBar,
    private titlecasePipe: TitleCasePipe,
    private mFirDatabase: AngularFireDatabase,
    private logService: LogService,
    private mCentreService: CentreService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.drDesignation$ = this.mFirDatabase.list<any>('types/Doctor Designation').valueChanges()
    this.centres$ = this.mCentreService.getAllCentres();
  }

  ngOnInit(): void {
    this.initForm();
    if (this.data) { // Check if data exists AND has drDetails
      console.log((this.data));
      this.patchFormValues();
    } else {
      this.addDrDetail(); // Call addDrDetail, not createDrDetail
      this.addSocialWorkerDetail();
      this.addAdminDetail();
      this.addNote();
    }
  }

  private initForm(): void {
    this.addressForm = this.fb.group({
      hospitalName: ['', Validators.required],
      address: ['', Validators.required],
      remark: [''],
      websiteLink: ['', Validators.required],
      shortName: ['', Validators.required],
      city: ['', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
      state: ['', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
      zipcode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('[0-9]*')]],
      drDetails: this.fb.array([]),
      notes: this.fb.array([]),
      socialWorkerDetails: this.fb.array([]),
      adminDetails: this.fb.array([]),
      forCentres: this.fb.control([])
    });
  }

  private patchFormValues(): void {
    if (this.data) {
      let associateCenters: any[] = [];
      if (this.data.isAssociateCenter) {
        if (Array.isArray(this.data.isAssociateCenter)) {
          associateCenters = this.data.isAssociateCenter;
        } else {
          associateCenters = Object.values(this.data.isAssociateCenter);
        }
      }
      this.addressForm.patchValue({
        hospitalName: this.data.hospitalName,
        address: this.data.address,
        websiteLink: this.data.websiteLink,
        shortName: this.data.shortName,
        city: this.data.city,
        state: this.data.state,
        zipcode: this.data.zipcode,
        forCentres: Array.isArray(this.data.forCentres) && this.data.forCentres.length
          ? this.data.forCentres
          : associateCenters.map((c: any) => c.centreCode)
      });


      if (this.data.drDetails && Array.isArray(this.data.drDetails)) {
        this.data.drDetails.forEach((dr: any) => {
          this.drDetail.push(
            this.fb.group({
              doctorsName: [dr?.doctorsName || '', Validators.required],
              designation: [dr?.designation || '', Validators.required],
              phoneNo: [dr?.phoneNo || '', [Validators.pattern(/^[0-9]{10}$/)]],
              email: [dr?.email || '', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]]
            })
          );
        });
      }

      if (this.data.socialWorkerDetails && Array.isArray(this.data.socialWorkerDetails)) {
        this.data.socialWorkerDetails.forEach((sw: any) => {
          this.socialWorkerDetail.push(
            this.fb.group({
              socialWorkerName: [sw?.socialWorkerName || ''],
              phoneNo: [sw?.phoneNo || '', [Validators.pattern(/^[0-9]{10}$/)]],
              email: [sw?.email || '', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]]
            })
          );
        });
      }

      if (this.data.notes && Array.isArray(this.data.notes)) {
        this.data.notes.forEach((n: any) => {
          this.notes.push(
            this.fb.group({
              remark: [n?.remark || '', Validators.required],
            })
          );
        });
      }

      if (this.data.adminDetails && Array.isArray(this.data.adminDetails)) {
        this.data.adminDetails.forEach((admin: any) => {
          this.adminDetail.push(
            this.fb.group({
              name: [admin?.name || ''],
              designation: [admin?.designation || ''],
              customDesignation: [admin?.customDesignation || ''],
              phoneNo: [admin?.phoneNo || '', [Validators.pattern(/^[0-9]{10}$/)]],
              email: [admin?.email || '', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]]
            })
          );
        });
      }
    }

    // fallback if nothing exists
    if (
      (!this.data.drDetails || this.data.drDetails.length === 0) &&
      (!this.data.socialWorkerDetails || this.data.socialWorkerDetails.length === 0) &&
      (!this.data.adminDetails || this.data.adminDetails.length === 0) &&
      (!this.data.notes || this.data.notes.length === 0)
    ) {
      this.addDrDetail();
      this.addSocialWorkerDetail();
      this.addAdminDetail();
      this.addNote();
    }
  }


  get drDetail(): FormArray {
    return this.addressForm.get('drDetails') as FormArray;
  }

  get notes(): FormArray {
    return this.addressForm.get('notes') as FormArray;
  }

  get socialWorkerDetail(): FormArray {
    return this.addressForm.get('socialWorkerDetails') as FormArray;
  }

  get adminDetail(): FormArray {
    return this.addressForm.get('adminDetails') as FormArray;
  }

  createDrDetail(): FormGroup {
    return this.fb.group({
      doctorsName: ['', Validators.required],
      designation: ['', Validators.required],
      phoneNo: ['', Validators.pattern(/^[0-9]{10}$/)],
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]]
    });
  }

  createSocialWorkerDetail(): FormGroup {
    return this.fb.group({
      socialWorkerName: [''],
      phoneNo: ['', Validators.pattern(/^[0-9]{10}$/)],
      email: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]]
    });
  }

  addDrDetail(): void {
    this.addressForm.markAsUntouched();
    this.drDetail.push(this.createDrDetail());
  }

  addSocialWorkerDetail(): void {
    this.socialWorkerDetail.push(this.createSocialWorkerDetail());
  }

  createAdminDetail(): FormGroup {
    return this.fb.group({
      name: [''],
      designation: [''],
      customDesignation: [''],
      phoneNo: ['', Validators.pattern(/^[0-9]{10}$/)],
      email: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]]
    });
  }

  addAdminDetail(): void {
    this.adminDetail.push(this.createAdminDetail());
  }

  removeAdminDetail(index: number): void {
    this.adminDetail.removeAt(index);
  }

  // removeDrDetail(index: number): void {
  //   this.drDetail.removeAt(index);
  // }
  removeDrDetail(index: number, dr: any) {
    const doctorName = dr.get('doctorsName')?.value || '';
    const dialogRef = this.dialog.open(DialogWithInputComponent, {
      width: '400px',
      data: {
        index,
        isShow: true,
        title: `Remove Doctor ${index + 1}`,
        message: `Are you sure you want to remove Doctor ${doctorName}?`
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const removedDoctor = dr.value;
        removedDoctor.status = 'Removed';
        removedDoctor.reason = result;
        // Track the deleted doctor
        this.deletedDrDetails.push(removedDoctor);
        console.log(`Doctor at index ${index} removed. Reason:`, result);
        this.drDetail.removeAt(index);
      }
    });
  }

  removeSocialWorkerDetail(index: number): void {
    this.socialWorkerDetail.removeAt(index);
  }

  createNote(): FormGroup {
    return this.fb.group({
      remark: ['', Validators.required]
    });
  }

  addNote() {
    this.notes.push(this.createNote());
  }

  removeNote(index: number) {
    this.notes.removeAt(index);
  }

  // onSubmit(): void {
  //   if (this.addressForm.invalid) {
  //     this.snackBar.open('Please enter the form properly', '', {duration: 3000});
  //     return;
  //   }
  //   this.isLoading = true;
  //   if (this.data) {
  //     const isAssociateCenter = (this.addressForm.value.isAssociateCenter || []).map((code: string) => ({centreCode: code}));
  //     const formData = {...this.addressForm.value, isAssociateCenter, removedDrDetails: {...this.deletedDrDetails}};
  //     console.log(formData)
  //     this.hospitalService.updatehospital(this.data.id, formData).then(() => {
  //       this.isLoading = false;
  //       this.snackBar.open('Hospital updated successfully', '', {duration: 3000});
  //       this.logService.addLog({
  //         date: Date.now(),
  //         section: 'Hospital',
  //         action: 'Update',
  //         description: `Hospital updated by ${this.userData?.email}`,
  //         currentIp: localStorage.getItem('currentip')!
  //       });
  //
  //       this.matDialogRef.close();
  //     });
  //   } else {
  //     const isAssociateCenter = (this.addressForm.value.isAssociateCenter || [])
  //       .map((code: string) => ({centreCode: code}));
  //     const formData = {
  //       ...this.addressForm.value,
  //       isAssociateCenter,
  //       removedDrDetails: {...this.deletedDrDetails},
  //       createdDate: new Date().toISOString(),
  //       addedBy: this.userData?.email
  //     };
  //     console.log(formData)
  //     this.hospitalService.addHospital(formData).then(() => {
  //       this.isLoading = false;
  //       this.logService.addLog({
  //         date: Date.now(),
  //         section: 'Hospital',
  //         action: 'Submit',
  //         description: `Hospital added by ${this.userData?.email}`,
  //         currentIp: localStorage.getItem('currentip')!
  //       });
  //       this.matDialogRef.close();
  //     });
  //   }
  // }


  onSubmit(): void {
    if (this.addressForm.invalid) {
      this.snackBar.open('Please enter the form properly', '', {duration: 3000});
      return;
    }

    const hospitalName = this.addressForm.value.hospitalName;
    const selectedCentres = this.addressForm.value.forCentres || [];

    if (!selectedCentres || selectedCentres.length === 0) {
      this.snackBar.open('Please select at least one centre', '', {duration: 3000});
      return;
    }

    this.isLoading = true;

    // Check for duplicate
    this.duplicateCheckSubscription = this.hospitalService
      .checkDuplicateHospital(hospitalName, selectedCentres, this.data?.id)
      .pipe(take(1))
      .subscribe(isDuplicate => {
        if (isDuplicate) {
          this.isLoading = false;
          this.snackBar.open(
            'This hospital already exists for one or more selected centres',
            'Close',
            {duration: 5000}
          );
          return;
        }

        // Proceed with save/update if no duplicate
        this.saveHospital();
      });
  }

// Create a separate method for saving
  private saveHospital(): void {
    // forCentres is the source of truth; isAssociateCenter is kept in the legacy shape for existing readers
    const forCentres: string[] = this.addressForm.value.forCentres || [];
    const isAssociateCenter = forCentres.map((code: string) => ({centreCode: code}));

    if (this.data) {
      const formData = {
        ...this.addressForm.value,
        forCentres,
        isAssociateCenter,
        removedDrDetails: {...this.deletedDrDetails}
      };

      this.hospitalService.updatehospital(this.data.id, formData).then(() => {
        this.isLoading = false;
        this.snackBar.open('Hospital updated successfully', '', {duration: 3000});
        this.logService.addLog({
          date: Date.now(),
          section: 'Hospital',
          action: 'Update',
          description: `Hospital updated by ${this.userData?.email}`,
          currentIp: localStorage.getItem('currentip')!
        });
        this.matDialogRef.close();
      }).catch(error => {
        this.isLoading = false;
        this.snackBar.open('Error updating hospital', '', {duration: 3000});
        console.error(error);
      });
    } else {
      const formData = {
        ...this.addressForm.value,
        forCentres,
        isAssociateCenter,
        removedDrDetails: {...this.deletedDrDetails},
        createdDate: new Date().toISOString(),
        addedBy: this.userData?.email
      };

      this.hospitalService.addHospital(formData).then(() => {
        this.isLoading = false;
        this.snackBar.open('Hospital added successfully', '', {duration: 3000});
        this.logService.addLog({
          date: Date.now(),
          section: 'Hospital',
          action: 'Submit',
          description: `Hospital added by ${this.userData?.email}`,
          currentIp: localStorage.getItem('currentip')!
        });
        this.matDialogRef.close();
      }).catch(error => {
        this.isLoading = false;
        this.snackBar.open('Error adding hospital', '', {duration: 3000});
        console.error(error);
      });
    }
  }

// Don't forget to clean up the subscription
  ngOnDestroy(): void {
    if (this.duplicateCheckSubscription) {
      this.duplicateCheckSubscription.unsubscribe();
    }
  }

  onCancel(): void {
    this.matDialogRef.close();
  }

  onBlur(formControl: FormControl): void {
    if (formControl.value) {
      formControl.setValue(this.titlecasePipe.transform(formControl.value.trim().toUpperCase()));
    }
  }
}


